export default __webpack_public_path__ + "static/media/resume.39089a05.pdf";